import { VideoCollectionVideo } from './VideoCollectionVideo';

export class SeriesCollectionVideo extends VideoCollectionVideo {
  get title(): string {
    if (!this.video.seriesSnippet) return this.video.title;

    return this.video.seriesSnippet.seasonSnippet.episodeSnippet.title;
  }
}
